
import { saveScheduleEidToCookie, barbaMarkup } from '../utils/func.js'
import { catchEmail } from '../utils/catch-email.js'
import { showLoadingModal, hideLoadingModal } from '../transitions/show-loading-modal.js'
import '../../vendor/jquery.magnific-popup-update.js'
import { saveGeolocation } from '../components/getGeolocation.js'
// import { triggerMatomo } from '../components/trigger-matomo'
export const postUrl = '/promotion/gift/ajax-start.js'
window.giftCardCheckout = void 0
export const prepareGiftCardHeader = false
export let salesCheckout

function showFormFieldErrorDisplay(formField, errorMessage) {
  const errorLabelId = formField.id + '-error'
  const errorLabel = document.getElementById(errorLabelId)
  if (errorLabel !== null) {
    errorLabel.innerHTML = errorMessage
  } else {
    formField.insertAdjacentHTML('afterend', `<label id="${errorLabelId}" class="error" for="${formField.id}">${errorMessage}</label>`)
  }
}

function validateFormField(formField) {
  let isValid = false
  let errorMessage = null
  if (formField.validity.valid) {
    if (formField.getAttribute('type') === 'email') {
      isValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(formField.value)
      if (!isValid) {
        errorMessage = FORM_VALIDATION_MAPPING[formField.name]
      } else if (formField.name === 'recipientEmailConfirm' && formField.value !== document.getElementById('recipientEmail').value) {
        isValid = false
        errorMessage = myvars.confirmEmailMsg
      } else if (formField.name === 'senderEmailConfirm' && formField.value !== document.getElementById('senderEmail').value) {
        isValid = false
        errorMessage = myvars.confirmSenderEmailMsg
      }
    } else if (formField.name === 'priceDisplay') {
      const giftAmount = document.getElementById("price").value
      isValid = !isNaN(giftAmount) && giftAmount > 0
      if (!isValid) {
        errorMessage = FORM_VALIDATION_MAPPING[formField.name]
      }
    } else {
      isValid = true
    }
  } else {
    errorMessage = FORM_VALIDATION_MAPPING[formField.name]
  }

  if (isValid) {
    document.getElementById(formField.id + '-error')?.remove()
  } else if (!isValid) {
    showFormFieldErrorDisplay(formField, errorMessage)
  }
  return isValid
}

function giftCardPrepareDom () {
  document.getElementById('sendMyself').addEventListener('click', function (event) {
    $('#recipientEmail').toggle()
    $('#recipientEmailConfirm').toggle()
  })

  if (myvars.giftCardSendMySelf) {
    document.getElementById('sendMyself').trigger('click')
  }

  const priceDisplay = document.getElementById('priceDisplay');
  priceDisplay.addEventListener('change', (event) => {
    let parsedNumber = null;
    if (event.target.value.trim() !== '') {
      parsedNumber = Locale.parseNumericString(event.target.value.trim(), myvars.langCode)
    }
    if (parsedNumber === null) {
      parsedNumber = 0
    }
    priceDisplay.value = Locale.formatNumber(parsedNumber, myvars.langCode)       
    document.getElementById('price').value = parsedNumber ?? 0
  })

  const formInputs = document.querySelectorAll('#gift input')
  formInputs.forEach((one) => {
    one.addEventListener('input', function (event) {
      validateFormField(this)
    })
    one.addEventListener('change', function (event) {
      validateFormField(this)
    })
  })
}

export function addGift () {
  const inputs = document.querySelectorAll('#gift input')
  const formFieldsToValidate = Object.keys(FORM_VALIDATION_MAPPING)
  let formValid = true
  let firstInvalidField = null
  for (const one of inputs) {
    if (
      formFieldsToValidate.includes(one.getAttribute('name')) &&
      one.checkVisibility()
    ) {
      const isValid = validateFormField(one)
      if (!isValid) {
        formValid = false
        if (firstInvalidField === null) {
          firstInvalidField = one
        }
      }
    }
  }

  if (!formValid) {
    firstInvalidField?.focus()
    return
  }

  giftCardSubmit()
}

function postGiftCard () {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: '/promotion/gift/ajax-start',
      type: 'POST',
      data: $('#gift').serialize(),
      cache: false,
      // dataType: 'json',
      timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
      success: (data, textStatus, xhr) => {
        if ($.parseJSON(data).status == 1) {
          const eid = $('#eid').html()
          const price = $('#price').val()
          const storeObj = $('#storeObj').val()
          const store = $('#store').val()
          const eventObj = $('#eventObj').val()
          const event = $('#event').val()
          const secondUrl = `/store/shopping-cart/add/item/${eid}/quantity/1/price/${price}/eventObj/${eventObj}/event/${event}/storeObj/${storeObj}/store/${store}/api/1`

          resolve(secondUrl)
        } else {
          alert('Invalid entry.')
          reject()
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        if (textStatus === 'timeout') {
          // alert(myvars.serverError) //Handle other error type
          // window.location.reload(true)
          reject(errorThrown)
        } else {
          // alert(myvars.serverError) //Handle other error type
          // window.location.reload(true)
          reject(errorThrown)
        }
      }
    })
  })
}

function postGiftCardSuccess (secondUrl) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: secondUrl,
      type: 'GET',
      cache: false,
      // dataType: 'json',
      success: (data, textStatus, xhr) => {
        hideLoadingModal()
        if (data.status === 1) {
        setCookie('giftCardCheckout', 1, 1, '')
        detectCheckoutType()
        if (salesCheckout) {
          window.location.href = '/store/order-helper-manager/fast-payment'
        } else {
          // const isOldIe = ieDetect().name === 'Explorer'
          if (window.myvars.onePageCheckout) {
            window.location.href = '/store/checkout'
          } else {
            window.location.href = '/store/order/review-cart'
          }
        }

        console.info('gift card ajax done!')
        } else {
          alert(data.message)
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        if (textStatus === 'timeout') {
          reject(errorThrown)
        } else {
          reject(errorThrown)
        }
      }
    })
  })
}

async function giftCardSubmit () {
  try {
    await showLoadingModal()
    const secondUrl = await postGiftCard()
    postGiftCardSuccess(secondUrl)
  } catch (errorThrown) {
    await hideLoadingModal()
    console.info(errorThrown)
  }
}

function giftSeatingChartPopup () {
  $('.popup-img').magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade'
  })
}

export function detectCheckoutType () {
  if ($('#gift-card-checkout').data('orderHelper') == 1) {
    salesCheckout = true
  } else {
    salesCheckout = false
  }
}

export function giftCardfastPayment () {
  if ($('#fast-payment-container').attr('data-gift-card-checkout') == 1) {
    giftCardCheckout = true
  } else {
    giftCardCheckout = false
  }
  if (giftCardCheckout) {
    giftCardfastPaymentMarkup()
  }
}

export function addGiftEditLink (id) {
  var $scheduleEid = getCookie('scheduleEid')
  var $giftcardEditURL =
    '/event/view/view/schedule/' + $scheduleEid + '/choice/gift'
}

export function giftcardEdit () {
  var $scheduleEid = getCookie('scheduleEid')
  var $giftcardEditURL =
    '/event/view/view/schedule/' + $scheduleEid + '/choice/gift'
  detectCheckoutType()
  window.location.href = $giftcardEditURL
}

export function giftCardfastPaymentMarkup () {
  $('.mobile-header-timer').remove()
  addGiftEditLink('#giftcard-edit-link')
  $('.back-to-seating-chart').hide()
  $('.cart-wrapper').hide()
}

export const GiftCard = {
  namespace: 'giftCard',
  beforeEnter (data) {
    barbaMarkup('giftCard')
    // giftCardCheckoutHeader()
    giftCardPrepareDom()
    giftSeatingChartPopup()
    // Barba.Prefetch.init()
    // return selectEventSchedule('#mobile-select-event-schedule')
  },
  afterEnter (data) {
    saveScheduleEidToCookie(myvars.scheduleEid)
    detectCheckoutType()
    catchEmail('#senderEmail')
    // alert("chart screen trans finish")
    // The Transition has just finished.
    // triggerMatomo(window.myvars.scheduleEid, 'giftCard')
    saveGeolocation()
  }
}

window.giftCardfastPayment = giftCardfastPayment
window.addGiftEditLink = addGiftEditLink
window.addGift = addGift
window.giftcardEdit = giftcardEdit
// export { giftCardCheckout }
